import React from 'react';
import Box from '../Common/Box';
import EventLog from './EventLog';
import {PortalWrapper} from '../Common/PortalWrapper';
import {Tab, Tabs} from '@mui/material';
import ControlButton from '../Common/ControlButton';
import MessageOutlined from '@mui/icons-material/MessageOutlined';
import UiSettings from './UiSettings';
import AppStats from './AppStats/AppStats';
import uiStore from "../lib/stores/uiStore";
import {observer} from "mobx-react";

const AppManager = () => {
    const [tabIndex, setTabIndex] = React.useState(0);

    const tabs = [
        {
            name: "Log",
            component: EventLog,
        },
        {
            name: "App Stats",
            component: AppStats,
        },
        {
            name: "UI Settings",
            component: UiSettings,
        },

    ]
    const CurrentComponent = tabs[tabIndex].component;

    if (!uiStore.isMobile) {
        return <PortalWrapper container={document.body}>
            <Box position={"fixed"} top={"100px"} maxWidth={"600px"} zIndex={1}>
                <AppStats/>
            </Box>

        </PortalWrapper>
    }

    const emptyList = document.getElementById("empty-list") || undefined;

    return <PortalWrapper container={uiStore.managerFocused ? document.body : undefined}>
        <Box
                top={0}
                expand
                column
                position={"absolute"}
                sx={{
                    bgcolor: theme => uiStore.managerFocused ? theme.palette.background.paper : "initial",
                    paddingBottom: !uiStore.managerFocused ? "75px" : "0",
                    pointerEvents: uiStore.managerFocused ? "all" : "none",
                }}
        >
            {uiStore.managerFocused &&
                    <>
                        <Box padding={"15px 15px 0 15px"} row justifyContent={"flex-end"}>
                            <ControlButton
                                    // sx={{marginLeft: "20px"}}
                                    width={35}
                                    enabled={uiStore.managerFocused}
                                    icon={MessageOutlined}
                                    onClick={() => {
                                        uiStore.managerFocused = !uiStore.managerFocused;
                                    }}
                            />
                        </Box>
                        <Tabs
                                value={tabIndex}
                                onChange={(event, tabIndex) => setTabIndex(tabIndex)}
                                variant="scrollable"
                                scrollButtons="auto"
                                aria-label="scrollable auto tabs example"
                        >
                            {
                                tabs.map(field => {
                                    return <Tab key={field.name} label={field.name}>
                                    </Tab>
                                })
                            }
                        </Tabs>
                    </>}
            <PortalWrapper
                    container={!uiStore.managerFocused ? emptyList : undefined}><CurrentComponent
                    focused={uiStore.managerFocused}/></PortalWrapper>
        </Box>
    </PortalWrapper>
};

export default observer(AppManager);
